import React, { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';
import { Group } from '../services/Group';

interface Props {
  cachedGroupList: Group[] | undefined;
  children: React.ReactNode;
}

export type GroupListContextType = {
  cachedGroupList: Group[] | undefined;
  setCachedGroupList: Dispatch<SetStateAction<Group[] | undefined>>;
};

const GroupListContext = createContext<GroupListContextType>({
  cachedGroupList: undefined,
  setCachedGroupList: () => console.warn('no List provider'),
});

export function useGroupListContext(): GroupListContextType {
  return useContext(GroupListContext);
}

export function GroupListProvider({ children }: Props): JSX.Element {
  const [cachedGroupList, setCachedGroupList] = useState<Group[] | undefined>(undefined);

  return <GroupListContext.Provider value={{ cachedGroupList, setCachedGroupList }}>{children}</GroupListContext.Provider>;
}
